import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking; false=guest
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    // Skip /auth/me while OAuth callback is in flight (session cookie not yet set)
    if (typeof window !== "undefined" && window.location.hash.includes("session_id=")) {
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      console.debug("auth/me failed", err?.response?.status);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    // fire and forget visit ping
    api.post("/track/visit").catch(() => {});
  }, [refresh]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return data;
    } catch (e) {
      setError(formatApiError(e));
      throw e;
    }
  };

  const register = async (payload) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return data;
    } catch (e) {
      setError(formatApiError(e));
      throw e;
    }
  };

  const completeMsg91PhoneLogin = async (accessToken) => {
    const { data } = await api.post("/auth/msg91/complete", {
      access_token: accessToken,
    });
    setUser(data);
    return data;
  };

  const completePhoneProfile = async (payload) => {
    const { data } = await api.patch("/auth/phone/profile", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider
      value={{
        user,
        error,
        login,
        register,
        logout,
        refresh,
        setError,
        completeMsg91PhoneLogin,
        completePhoneProfile,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
